import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import useSeo from "@/hooks/useSeo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useSeo({ title: "Acceso redacción" });

  useEffect(() => { if (ready && user) navigate("/redaccion-nexodum", { replace: true }); }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/redaccion-nexodum", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo iniciar sesión.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-nx-dark px-4 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 opacity-25" style={{ background: "radial-gradient(circle at 70% 20%, #0055FF 0%, transparent 45%), radial-gradient(circle at 25% 85%, #FF6B35 0%, transparent 40%)" }} />
      <div className="relative w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <LogoMark size={60} />
          <h1 className="font-sans font-black text-2xl text-white mt-4">NEX<span className="nx-gradient-text">O</span>DUM</h1>
          <p className="text-slate-400 text-xs uppercase tracking-[0.3em] mt-1">Acceso a la redacción</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-lg p-8 space-y-5" data-testid="admin-login-form">
          <div><Label htmlFor="email">Email</Label><Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-1.5" placeholder="admin@nexodum.com" /></div>
          <div><Label htmlFor="password">Contraseña</Label><Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-1.5" placeholder="••••••••" /></div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full nx-gradient-bg text-white font-bold py-3 rounded-md text-sm uppercase tracking-wider hover:opacity-90 transition-opacity disabled:opacity-50">
            {loading ? "Ingresando…" : "Ingresar"}
          </button>
          <p className="text-center text-xs text-gray-400">Área privada · Acceso restringido</p>
        </form>
      </div>
    </div>
  );
}
